import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Skeleton } from "@/components/ui/skeleton";
import { RealEstateDetailMobileScaffold } from "./RealEstateDetailMobileScaffold";
import { DetailHeaderBlock, DetailFactsRow, DetailAttributeRows } from "./RealEstateDetailMobileSections";

// Same scaffold + section primitives as RealEstateDetailMobile, so the loading
// state and the loaded layout share one structure and can't drift.
// `showRail` mirrors a room-house detail (rendered when the active search is
// room-rent, where the loaded detail shows the sibling-room rail).
export default function RealEstateDetailMobileSkeleton(t0) {
  const $ = _c(12);
  const {
    showRail
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  let t1;
  if ($[0] !== t) {
    t1 = t("back");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-[45vh] w-full rounded-none" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DetailHeaderBlock data-sentry-element="DetailHeaderBlock" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx"><Skeleton className="h-7 w-2/3" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" /><Skeleton className="h-5 w-24 mt-1" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" /><Skeleton className="h-4 w-44 mt-1" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" /></DetailHeaderBlock>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DetailFactsRow items={[<Skeleton key="a" className="h-4 w-16" />, <Skeleton key="b" className="h-4 w-16" />, <Skeleton key="c" className="h-4 w-20" />]} data-sentry-element="DetailFactsRow" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== showRail) {
    t5 = showRail && <div className="mt-4 -mx-2 flex gap-1 overflow-hidden px-2 py-0.5">{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[5] = showRail;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DetailAttributeRows rows={Array.from({
      length: 4
    }).map(_temp2)} data-sentry-element="DetailAttributeRows" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-6"><Skeleton className="h-5 w-28 mb-2" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" /><Skeleton className="h-56 w-full rounded-lg" data-sentry-element="Skeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx" /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t1 || $[10] !== t5) {
    t8 = <RealEstateDetailMobileScaffold backLabel={t1} scrollable={false} hero={t2} data-sentry-element="RealEstateDetailMobileScaffold" data-sentry-component="RealEstateDetailMobileSkeleton" data-sentry-source-file="RealEstateDetailMobileSkeleton.tsx">{t3}{t4}{t5}{t6}{t7}</RealEstateDetailMobileScaffold>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp2(__0, i_0) {
  return {
    label: <Skeleton key={`l${i_0}`} className="h-4 w-24" />,
    value: <Skeleton key={`v${i_0}`} className="h-4 w-20" />
  };
}
function _temp(_, i) {
  return <div key={i} className="w-32 shrink-0 overflow-hidden rounded-xl border border-border bg-card"><Skeleton className="h-20 w-full rounded-none" /><div className="px-2 py-1.5"><Skeleton className="h-3 w-20" /></div></div>;
}